export default[
    {
        path: '/mantenimiento',
        component: () => import(/* webpackChunkName: "mtto" */ '@/views/Mantenimiento.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_MTTO'],
        },
        children:[
            {
                path:'/',
                name:'mttoMain',
                component: () => import(/* webpackChunkName: "mttoPrincipal" */ '@/views/mantenimiento/MantenimientoPrincipal.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_MTTO'],
                },
            },
            {
                path:'generador',
                name:'mttoGenerador',
                component: () => import(/* webpackChunkName: "mttoGenerador" */ '@/views/mantenimiento/BitacoraGenerador.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_MTTO'],
                },
            },
            {
                path:'planta',
                name:'mttoPlanta',
                component: () => import(/* webpackChunkName: "mttoPlanta" */ '@/views/mantenimiento/BitacoraPlanta.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_MTTO'],
                },
            },
            {
                path:'extintores',
                name:'mttoExtintores',
                component: () => import(/* webpackChunkName: "mttoExtintor" */ '@/components/mantenimiento/MttoExtintores.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_MTTO'],
                },
            },
            {
                path:'detectores',
                name:'mttoDetectores',
                component: () => import(/* webpackChunkName: "mttoDetectores" */ '@/views/mantenimiento/BitacoraDetectores.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_MTTO'],
                },
            },
            {
                path:'aseo',
                name:'mttoAseo',
                component: () => import(/* webpackChunkName: "mttoAseo" */ '@/views/mantenimiento/BitacoraAseo.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_MTTO'],
                },
            },
        ]
    }
]